import { useState, Children, isValidElement, cloneElement } from 'react';
import styled from 'styled-components';

type Props = {
  readonly children: JSX.Element | JSX.Element[];
  readonly activeIndex?: number | null | undefined;
  readonly onActiveIdChanged?: (arg0: number) => void;
};
const Wrapper = styled.div`
  display: flex;
  align-self: flex-start;
  flex-direction: column;
  align-items: stretch;
  background-color: ${({ theme }) => theme.orbit.backgroundColor};
  width: 100%;
`;

// Accessible tabs: https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-1/tabs.html

// Tabs example
// <Tabs>
//   <TabsHeader>
//     <TabsHeaderItem>...</TabsHeaderItem>
//     <TabsHeaderItem>...</TabsHeaderItem>
//   </TabsHeader>
//   <TabsBody>
//     <TabsPanel>...</TabsPanel>
//     <TabsPanel>...</TabsPanel>
//   </TabsBody>
// </Tabs>
//

type ClonedElementProps = {
  activeId: number;
  setActiveId: (number) => void;
};

const Tabs = ({ children, activeIndex, onActiveIdChanged }: Props): JSX.Element => {
  const [activeId, setActiveId] = useState(activeIndex ?? 0);

  const onActiveIdChange = (id: number) => {
    setActiveId(id);

    if (onActiveIdChanged !== undefined) {
      onActiveIdChanged(id);
    }
  };

  const modifiedChildren = Children.map(children, (child) => {
    return isValidElement(child)
      ? cloneElement<Partial<ClonedElementProps>>(child, {
          activeId,
          setActiveId: onActiveIdChange,
        })
      : null;
  });
  return <Wrapper>{modifiedChildren}</Wrapper>;
};

export default Tabs;
